import { apiService } from './api';
import { HappyHourRuleListDTO, HappyHourRuleDTO, CreateHappyHourRuleDTO, ActiveHappyHourDTO } from '../types';

const happyHourService = {
  getAll: () =>
    apiService.get<{ data: HappyHourRuleListDTO[] }>('/happy-hours'),

  getById: (id: number) =>
    apiService.get<{ data: HappyHourRuleDTO }>(`/happy-hours/${id}`),

  getActive: () =>
    apiService.get<{ data: ActiveHappyHourDTO | null }>('/happy-hours/active'),

  create: (dto: CreateHappyHourRuleDTO) =>
    apiService.post<{ data: HappyHourRuleDTO }>('/happy-hours', dto),

  update: (id: number, dto: CreateHappyHourRuleDTO) =>
    apiService.put<{ data: HappyHourRuleDTO }>(`/happy-hours/${id}`, dto),

  delete: (id: number) =>
    apiService.delete(`/happy-hours/${id}`),
};

export default happyHourService;
